import { AppService } from "app/services/app.service";

import { ConfigPsimRequestParams } from "app/models/configpsim.model";
import { Observable } from "rxjs";

export abstract class AbConfigPsim extends AppService {

  abstract getConfig(params?: ConfigPsimRequestParams): Observable<any>;
  abstract getConfigPublic(params?: ConfigPsimRequestParams): Observable<any>;
  abstract getConfigWebHook(): Observable<any>;
  abstract testeConexao(obj: any): Observable<any>;
  abstract salvar(obj: any): Observable<any>;
  abstract desvincularConta(obj: any): Observable<any>;
  abstract getContaPSIM(contaId: number): Observable<any>;
  abstract getContasPSIM(): Observable<any>;
  abstract getDivisoesPSIM();
  abstract getAllConfigAvancadasByTipo(tipo: string): Observable<any>;
  abstract salvarAvancadas(objs: any): Observable<any>;
  abstract salvarConfigGrupo(objs: any): Observable<any>;
  abstract salvarSincronizarPessoas(objs: any): Observable<any>;
  abstract getAllConfigAvancadas(): Observable<any>;
  abstract getAllPerfilAtivos();
  abstract getAllIntegracaoGrupoPerfil();
}